import { FC, useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import Loader from "@components/new/Loader/Loader";
import { iChainMenuItems } from "@apiHooks/useChainsMenuItems";
import WhoOffers from "../WhoOffers";
import { intersectByChainIds, NO_INCLUDE_TERMS_MESSAGE } from "./ChainsFoodsTab.helpers";
import "./ChainsFoodsTab.styles.scss";

interface iProps {
    includes: string[];
    chainIds: number[];
    rows: iChainMenuItems[];
    isLoading: boolean;
    isSuccess: boolean | null;
}

const ChainsFoodsTab: FC<iProps> = ({ includes, chainIds, rows, isLoading, isSuccess }) => {
    const hasIncludes = includes.length > 0;

    const visibleRows = useMemo(() => intersectByChainIds(rows, chainIds), [rows, chainIds]);

    useEffect(() => {
        if (hasIncludes && isSuccess === false) {
            toast.error("Couldn't load the featured menu items. Please try again.");
        }
    }, [hasIncludes, isSuccess]);

    if (!hasIncludes) {
        return (
            <div className="NewTopChains__table ChainsFoodsTab ChainsFoodsTab--empty">
                <div
                    className="ChainsFoodsTab__prompt"
                    data-testid="textFoodsNoIncludeTerms"
                >
                    {NO_INCLUDE_TERMS_MESSAGE}
                </div>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="NewTopChains__table ChainsFoodsTab ChainsFoodsTab--empty">
                <Loader/>
            </div>
        );
    }

    return (
        <WhoOffers
            data={visibleRows}
            menuIncludes={includes}
            className="ChainsFoodsTab"
            testId="tableChainsFoods"
        />
    );
};

export default ChainsFoodsTab;
